import { QarepaEnumInformation } from '@qarepa/common';

export enum EmployeeAbsenceStatusEnum {
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  CREATED = 'CREATED',
  INACTIVE = 'INACTIVE',
}

export type EmployeeAbsenceStatusType =
  | EmployeeAbsenceStatusEnum.ACTIVE
  | EmployeeAbsenceStatusEnum.APPROVED
  | EmployeeAbsenceStatusEnum.CREATED
  | EmployeeAbsenceStatusEnum.INACTIVE;

export const EmployeeAbsenceStatusArray = [
  EmployeeAbsenceStatusEnum.ACTIVE,
  EmployeeAbsenceStatusEnum.APPROVED,
  EmployeeAbsenceStatusEnum.CREATED,
  EmployeeAbsenceStatusEnum.INACTIVE,
];

export const EmployeeAbsenceStatusInfo: QarepaEnumInformation<EmployeeAbsenceStatusEnum> =
  {
    [EmployeeAbsenceStatusEnum.ACTIVE]: {
      name: $localize`Activo`,
    },
    [EmployeeAbsenceStatusEnum.APPROVED]: {
      name: $localize`Aprobado`,
    },
    [EmployeeAbsenceStatusEnum.CREATED]: {
      name: $localize`Creado`,
    },
    [EmployeeAbsenceStatusEnum.INACTIVE]: {
      name: $localize`Inactivo`,
    },
  };
